import $ from 'jquery';
import 'ms-signalr-client';
import auth from '../Login/authService'
import {
	updateActivityOrganizer,
	addUnreadChatMessage,
	updateActivity,
	updateActivityRegistered
} from '../Project/ActivityOverview/actions'
import {
	addReadChatMessage
} from '../Project/RegisterActivities/Chat/actions'
import {
	attemtUpdateDayConflicting
} from '../Project/Salary/actions'
import {
	updateProjectSummary
} from '../Project/Dashboard/actions'
import {
	updateWorkplaceOrganizer,
	addUnreadChatMessageInKanban,
	addMissingWorkplaces
} from '../ShortTermProjects/Kanban/actions'
import { isDatesSameDay } from '../Util/dateTime';


//Requires a LOGING_SUCCCES
export default store => next => action => {

	//if user is logged in do stuff

	if (auth.loggedIn() && (window.connection === undefined || (window.connection && window.connection.state === 4))) {

		var token = auth.getToken();

		$.signalR.ajaxDefaults.headers = { Authorization: "Bearer " + token };
		window.connection = $.hubConnection(process.env.REACT_APP_webApiEndPoint);
		var proxy = window.connection.createHubProxy('MainHub');

		// receives broadcast messages from a hub function, called "broadcastMessage"


		proxy.on('setUnreadChatMessage', function (obj) {
			if (store.getState().activityOverviewReducer.project.id === obj.projectId) {
				store.dispatch(addUnreadChatMessage(obj.activityId))
			}
			if (store.getState().routing.location) {
				if (store.getState().routing.location.pathname.endsWith('tilbud/registrer/' + obj.activityId)) {
					store.dispatch(addReadChatMessage(obj.activityId, obj.chatMessage))
				}
				if (store.getState().routing.location.pathname.endsWith('afdeling/' + obj.projectId + "/arbejdssted/" + obj.activityId + "/oversigt")) {
					store.dispatch(addReadChatMessage(obj.activityId, obj.chatMessage))
				}
				if (store.getState().routing.location.pathname.endsWith('afdeling/' + obj.projectId)) {
					store.dispatch(addUnreadChatMessageInKanban(obj.activityId))
				}
			}
		});

		proxy.on('updateOrganizer', function (obj) {
			if (store.getState().activityOverviewReducer.project.id === obj.projectId) {
				store.dispatch(updateActivityOrganizer(obj.activityOrganizer))
			}
		});

		proxy.on('updateHoursOnActivity', function (obj) {
			if (store.getState().activityOverviewReducer.project.id === obj.projectId) {
				//if its the same date, update whoel activity, else only update totalt registered
				if (isDatesSameDay(new Date(obj.date), store.getState().activityOverviewReducer.date)) {
					store.dispatch(updateActivity(obj.activityId, obj.registered, obj.today, obj.pool))
				}
				else {
					store.dispatch(updateActivityRegistered(obj.activityId, obj.registered))
				}

			}
		});

		proxy.on('markRegistrationConflicting', function (obj) {
			if (store.getState().salaryReducer.projects[obj.projectId]) {
				store.dispatch(attemtUpdateDayConflicting(obj.id, obj.conflictsWith, obj.employeeId, obj.projectId, obj.conflictingProjects))
			}

		});

		proxy.on('markRegistrationSolved', function (obj) {
			if (store.getState().salaryReducer.projects[obj.projectId]) {
				store.dispatch(attemtUpdateDayConflicting(obj.id, null, obj.employeeId, obj.projectId))
			}
		});

		proxy.on('updateProjectSummary', function (obj) {
			if (store.getState().routing.location) {
				if (store.getState().routing.location.pathname === '/tilbud' && auth.getProfile().role === "Insights") {
					store.dispatch(updateProjectSummary(obj.projectId, obj.summary))
				}
			}
		});

		proxy.on('updatWorkplaceeOrganizer', function (obj) {
			if (store.getState().kanbanReducer.departmentId == obj.departmentId) {
				if (obj.workplace) {
					store.dispatch(addMissingWorkplaces({ [obj.workplace.id]: obj.workplace }))
				}
				store.dispatch(updateWorkplaceOrganizer(obj.workplaceOrganizer))
			}
		});


		// atempt connection, and handle errors
		window.connection.start({})
			.done(function () { })
			.fail(function () {
				return;
			});
	}

	return next(action)
}




// WEBPACK FOOTER //
// ./src/App/MainClient/connectSignalRMiddleware.js